/**
 * ============================================================================
 * QUERY PROVIDER (React Query)
 * ============================================================================
 *
 * Provides React Query for server state management.
 * Uses @tanstack/react-query (see package.json).
 */

import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// Default query client (stable for app lifetime)
const defaultQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes (v5 renamed cacheTime to gcTime)
    },
    mutations: {
      retry: false,
    },
  },
});

/**
 * Query Provider Component
 * @param {Object} props
 * @param {React.ReactNode} props.children
 * @returns {JSX.Element}
 */
export const QueryProvider = ({ children }) => {
  return (
    <QueryClientProvider client={defaultQueryClient}>
      {children}
    </QueryClientProvider>
  );
};

export default QueryProvider;
